import domready from "domready";
import "./navigation--viewport";
domready(function () {
  var $secondLevels = document.getElementsByClassName("navigation--second-level");
  var viewport;
  var checkPosition = function (entries) {
    var element = entries[0];
    var target = element.target;
    var elementHeight = element.boundingClientRect.height;
    var elementRight = element.boundingClientRect.right;
    var elementBottom = element.boundingClientRect.bottom;
    var rootWidth = element.rootBounds.width;
    var rootHeight = element.rootBounds.height;
    if (elementRight > rootWidth) {
      target.style.left = "";
      target.style.right = 0;
    } else {
      target.style.right = "";
      target.style.left = 0;
    }
    checkNavHeight(target, elementBottom, rootHeight);
    var $thirdLevels = target.getElementsByClassName("navigation--third-level");
    Array.prototype.forEach.call($thirdLevels, function (thirdLevel, i) {
      var parent = thirdLevel.parentElement;
      var parentRect = parent.getBoundingClientRect();
      var parentHeight = parentRect.height;
      var thirdLevelRect = thirdLevel.getBoundingClientRect();
      var thirdLevelChildren = thirdLevel.getElementsByTagName("li");
      var thirdLevelHeight = parentHeight * thirdLevelChildren.length;
      var thirdLevelTop = thirdLevelRect.top;
      parent.addEventListener("mouseenter", function () {
        if (viewport !== "desktop") {
          return;
        }
        var targetRect = target.getBoundingClientRect();
        elementHeight = targetRect.height;
        thirdLevelRect = thirdLevel.getBoundingClientRect();
        thirdLevelHeight = thirdLevelRect.height;
        if (thirdLevelHeight < elementHeight) {
          thirdLevel.style.height = elementHeight + "px";
        }
      });
      checkNavHeight(thirdLevel, thirdLevelTop + thirdLevelHeight, rootHeight);
      thirdLevelRect = thirdLevel.getBoundingClientRect();
      var thirdLevelRight = thirdLevelRect.width + elementRight;
      if (thirdLevelRight > rootWidth) {
        thirdLevel.style.left = "";
        thirdLevel.style.right = "100%";
      } else {
        thirdLevel.style.left = "100%";
        thirdLevel.style.right = "";
      }
    });
  };
  window.addEventListener("orientationchange", function () {
    viewport = window.navigationViewport;
    if ($secondLevels !== null && viewport === "desktop") {
      Array.prototype.forEach.call($secondLevels, function (secondLevel) {
        var navLevelObserver = new window.IntersectionObserver(checkPosition);
        navLevelObserver.observe(secondLevel);
      });
    } else {
      Array.prototype.forEach.call($secondLevels, function (secondLevel) {
        secondLevel.style.left = 0;
        secondLevel.style.right = "";
        var $thirdLevels = secondLevel.getElementsByClassName("navigation--third-level");
        Array.prototype.forEach.call($thirdLevels, function (thirdLevel, i) {
          thirdLevel.style.left = "";
          thirdLevel.style.right = "";
          thirdLevel.classList.remove("navigation--50-50");
          thirdLevel.style.height = "";
        });
      });
    }
  });
  window.addEventListener("resize", function () {
    viewport = window.navigationViewport;
    if ($secondLevels !== null && viewport === "desktop") {
      Array.prototype.forEach.call($secondLevels, function (secondLevel) {
        var navLevelObserver = new window.IntersectionObserver(checkPosition);
        navLevelObserver.observe(secondLevel);
      });
    } else {
      Array.prototype.forEach.call($secondLevels, function (secondLevel) {
        secondLevel.style.left = 0;
        secondLevel.style.right = "";
        var $thirdLevels = secondLevel.getElementsByClassName("navigation--third-level");
        Array.prototype.forEach.call($thirdLevels, function (thirdLevel, i) {
          thirdLevel.style.left = "";
          thirdLevel.style.right = "";
          thirdLevel.classList.remove("navigation--50-50");
          thirdLevel.style.height = "";
        });
      });
    }
  });
  window.addEventListener("navigationChange", function () {
    viewport = window.navigationViewport;
    if ($secondLevels !== null && viewport === "desktop") {
      Array.prototype.forEach.call($secondLevels, function (secondLevel) {
        var navLevelObserver = new window.IntersectionObserver(checkPosition);
        navLevelObserver.observe(secondLevel);
      });
    } else {
      Array.prototype.forEach.call($secondLevels, function (secondLevel) {
        secondLevel.style.left = 0;
        secondLevel.style.right = "";
        var $thirdLevels = secondLevel.getElementsByClassName("navigation--third-level");
        Array.prototype.forEach.call($thirdLevels, function (thirdLevel, i) {
          thirdLevel.style.left = "";
          thirdLevel.style.right = "";
          thirdLevel.classList.remove("navigation--50-50");
          thirdLevel.style.height = "";
        });
      });
    }
  });
  viewport = window.navigationViewport;
  if ($secondLevels !== null && viewport === "desktop") {
    Array.prototype.forEach.call($secondLevels, function (secondLevel) {
      var navLevelObserver = new window.IntersectionObserver(checkPosition);
      navLevelObserver.observe(secondLevel);
    });
  } else {
    Array.prototype.forEach.call($secondLevels, function (secondLevel) {
      secondLevel.style.left = 0;
      secondLevel.style.right = "";
      var $thirdLevels = secondLevel.getElementsByClassName("navigation--third-level");
      Array.prototype.forEach.call($thirdLevels, function (thirdLevel, i) {
        thirdLevel.style.left = "";
        thirdLevel.style.right = "";
        thirdLevel.classList.remove("navigation--50-50");
        thirdLevel.style.height = "";
      });
    });
  }
});
function checkNavHeight(el, elBottom, rootHeight) {
  var childLevels = el.getElementsByTagName("ul");
  if (childLevels.length === 0 && elBottom > rootHeight) {
    el.classList.add("navigation--50-50");
  } else {
    el.classList.remove("navigation--50-50");
  }
}
